<footer class="footer d-flex col-md-12 w-100 flex-column h-100 justify-content-center">
  <div class="footer-top d-flex justify-content-center flex-wrap">
    <footer-help [urlConfigData]="urlConfigData"></footer-help>
    <footer-contact [emailConfigData]="emailConfigData"></footer-contact>
  </div>
  <div class="footer-bottom d-flex justify-content-center">
    <span>Copyright &#169; {{ currentYear }} Network Rail</span>
  </div>

  <nr-icon
    id="scroll-to-top"
    tabindex="0"
    [name]="icons.SCROLL_TO_TOP"
    sizeClass="icon-size-32"
    class="info-icon-align cursor-pointer scroll-to-top"
    (click)="scrollToTop()"
    [attr.aria-label]="'Scroll To top button'"
  ></nr-icon>
</footer>
